import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const BrandLogo = () => {
  const theme = useTheme();
  
  return (
    <Box
      component="a"
      href="#home"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        mr: 2,
        transition: "all 0.3s ease",
        cursor: "pointer",
        textDecoration: "none",
        "&:hover": {
          transform: "scale(1.05)",
        },
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontWeight: 750,
          color: theme.palette.secondary.main,
          lineHeight: 1,
          letterSpacing: "1px",
          fontSize: { xs: "1.1rem", sm: "1.25rem" },
          textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
          transition: "all 0.3s ease",
        }}
      >
        SAINI
      </Typography>
      <Typography
        variant="body1"
        sx={{
          fontWeight: 600,
          color: theme.palette.primary.light,
          letterSpacing: "4px",
          textTransform: "uppercase",
          mt: "-2px",
          fontSize: { xs: "0.5rem", sm: "0.7rem" },
          transition: "all 0.3s ease",
          opacity: 0.8,
        }}
      >
        COLLECTION
      </Typography>
    </Box>
  );
};

export default BrandLogo;